import { config } from '../config';

export function BetaDisclaimerPage(): JSX.Element {
  return (
    <div className="max-w-3xl space-y-6">
      <h1 className="text-2xl font-semibold text-white">Beta Disclaimer</h1>

      <p className="text-sm text-gray-300">
        This service is currently in beta. It is provided <strong className="text-white">as is</strong>, without
        warranty of any kind. We make no guarantee of availability, reliability, or suitability
        for any particular purpose. Features may change or be removed without notice.
      </p>
      <p className="text-sm text-gray-300">
        To the extent permitted by law, our liability for any loss or damage arising from your
        use of this beta service is limited.
      </p>
      <p className="text-sm text-gray-300">
        Questions or feedback?{' '}
        <a className="text-red-400 hover:text-red-300 underline" href={`mailto:${config.supportEmail}`}>
          {config.supportEmail}
        </a>
      </p>
    </div>
  );
}
